import React from "react";
import Typo from "@material-ui/core/Typography";
import "./GalleryCard.scss";

export class GalleryCard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      title: props.title,
      description: props.description,
      imageUrl: props.imageSrc,
      isHovered: false,
    };

    const a = props.imageUrl;
    a.replace(" ", "%20");
    this.state.imageUrl = a;
  }

  Redirect = () => {
    this.props.reduxDispatcher({
      type: "SET_POST",
      payload: {
        title: this.state.title,
        description: this.state.description,
        url: this.state.imageUrl,
      },
    });
    setTimeout(() => {
      this.props.history.push(`gallery/post`);
    }, 300);
  };

  render() {
    return (
      <div
        className="row mr-md-2 post p-5 text-right rounded-lg shadow glassEffect"
        onMouseEnter={() => this.setState({ isHovered: true })}
        onMouseLeave={() => this.setState({ isHovered: false })}
        onClick={this.Redirect}
      >
        <img
          className={`${this.state.isHovered ? "postImgHover" : "postImg"}`}
          src={this.state.imageUrl}
          alt={this.state.imageUrl}
        />
        <div className={`col-12 mt-3`}>
          <Typo variant="h5" className="font-weight-bold text-white">
            {this.state.title}
          </Typo>
        </div>
        <div className="col-12">
          <Typo variant="body2" className="font-weight-bold text-white">
            {this.state.description.substring(0, 20)}
            {this.state.description.length > 29 ? "..." : ""}
          </Typo>
        </div>
      </div>
    );
  }
}

export default GalleryCard;
